import { authorizationType } from '#authorization/constants';
import { detailsType } from '#details/constants';
import { photographType } from '#photographs/constants';
import { SlotType } from '#record/model';
import { classname } from 'apprise-ui/component/model';
import { IconBaseProps, IconType } from 'react-icons';
import { FaClipboardList } from "react-icons/fa";
import { MdOutlineAddCircle, MdRemoveCircle, MdRemoveCircleOutline } from "react-icons/md";

export const avlType = 'avl'
export  const avlPrefix = 'AVL'

export const patchedTypes: SlotType[] = [detailsType, authorizationType, photographType, avlType]
export const additionalPatchedTypeMatches: SlotType[][] = [[avlType],[detailsType, authorizationType, avlType],[detailsType, avlType], [detailsType, photographType, avlType], [authorizationType, photographType, avlType]]

export const AvlIcon = FaClipboardList

export const RevokeIcon = (props: IconBaseProps & { full?: boolean }) => {

    const { full, className, ...rest } = props

    const Icon = props.full ? MdRemoveCircle : MdRemoveCircleOutline

    return <Icon className={classname('revoke-icon', className)} {...rest} />
}


export const RestoreIcon: IconType = props => <MdOutlineAddCircle className='unrevoke-icon' {...props} />
